document.addEventListener("DOMContentLoaded", function () {
    const blockImages = Array.from(document.querySelectorAll('main .wp-block-image'));

    if (blockImages.length > 0) {
        blockImages.forEach(blockImage => {
            /**
             * Create image container, border, and wrapper
             * Add class to each element
             * Add element to page
             */
            const image = blockImage.querySelector('img');
            if (image) {
                const imageParent = image.parentElement;

                /**
                 * On image hover, update border radiuses
                 */
                const style = image.style;
                let imageBorderTopLeftRadius = style.borderTopLeftRadius;
                let imageBorderTopRightRadius = style.borderTopRightRadius;
                let imageBorderBottomLeftRadius = style.borderBottomLeftRadius;
                let imageBorderBottomRightRadius = style.borderBottomRightRadius;
                imageParent.style.borderTopLeftRadius = imageBorderTopLeftRadius;
                imageParent.style.borderTopRightRadius = imageBorderTopRightRadius;
                imageParent.style.borderBottomLeftRadius = imageBorderBottomLeftRadius;
                imageParent.style.borderBottomRightRadius = imageBorderBottomRightRadius;
                
                image.addEventListener('mouseenter', event => {
                    style.borderTopLeftRadius = imageBorderBottomRightRadius;
                    style.borderTopRightRadius = imageBorderBottomLeftRadius;
                    style.borderBottomLeftRadius = imageBorderTopRightRadius;
                    style.borderBottomRightRadius = imageBorderTopLeftRadius;
                    imageParent.style.borderTopLeftRadius = imageBorderBottomRightRadius;
                    imageParent.style.borderTopRightRadius = imageBorderBottomLeftRadius;
                    imageParent.style.borderBottomLeftRadius = imageBorderTopRightRadius;
                    imageParent.style.borderBottomRightRadius = imageBorderTopLeftRadius;
                });
                image.addEventListener('mouseleave', event => {
                    style.borderTopLeftRadius = imageBorderTopLeftRadius;
                    style.borderTopRightRadius = imageBorderTopRightRadius;
                    style.borderBottomLeftRadius = imageBorderBottomLeftRadius;
                    style.borderBottomRightRadius = imageBorderBottomRightRadius;
                    imageParent.style.borderTopLeftRadius = imageBorderTopLeftRadius;
                    imageParent.style.borderTopRightRadius = imageBorderTopRightRadius;
                    imageParent.style.borderBottomLeftRadius = imageBorderBottomLeftRadius;
                    imageParent.style.borderBottomRightRadius = imageBorderBottomRightRadius;
                });
            }
        });
    }
});